// extracted by mini-css-extract-plugin
export default {"container":"ViewRisk_container__bZzIN","fields":"ViewRisk_fields__K8ovx"};